import { apiFetch } from "@/api/client";
import type { CurrentUser, LoginResponse } from "@/types/auth";

export function login(username: string, password: string): Promise<LoginResponse> {
  return apiFetch<LoginResponse>("/auth/login", {
    method: "POST",
    skipAuthRetry: true,
    body: JSON.stringify({ username, password }),
  });
}

export function verifyMfa(mfaToken: string, code: string): Promise<LoginResponse> {
  return apiFetch<LoginResponse>("/auth/mfa/verify", {
    method: "POST",
    skipAuthRetry: true,
    body: JSON.stringify({ mfa_token: mfaToken, code }),
  });
}

export function fetchCurrentUser(): Promise<CurrentUser> {
  return apiFetch<CurrentUser>("/auth/me");
}

export function logout(): Promise<void> {
  return apiFetch<void>("/auth/logout", { method: "POST" });
}
